import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { BuyWithMplus } from 'widgets/mplus/buy-with-mplus'

import { IExcursionDetails } from 'shared/api/excursions/list/model'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import {
  getDifficultValue,
  getDurationValue,
} from 'shared/lib/excursions/getValueInLists'
import { priceShow } from 'shared/lib/priceShow'
import { MbonusLineInfo } from 'shared/ui/mbonus/mbonus-line-info'
import MBonusLine from 'shared/ui/mbonus/mbonus-line/mbonus-line'
import { Paper } from 'shared/ui/paper'

import s from './guide-info.module.scss'

type Props = {
  excursionDetails: IExcursionDetails
  isMyOrders?: boolean
  totalPrice?: string
  bonusAmount?: string
}

export const GuideInfo = ({
  excursionDetails,
  isMyOrders,
  totalPrice,
  bonusAmount,
}: Props) => {
  const { t } = useTranslation()

  const renderDetailItem = (label: string, value: string | number) => (
    <li className={s.listItem}>
      {t(label)}
      <span className={s.listItemRight}>{value}</span>
    </li>
  )

  const duration = excursionDetails?.duration
  const excursionType = excursionDetails?.excursion_type?.value
  const difficultyLevel = excursionDetails?.difficulty_level
  const startDate = excursionDetails.departure_date

  const isMplus = excursionDetails.is_mplus
  const mplus_amount = excursionDetails.mplus_amount_per_user

  // TODO check
  const price = String(
    mplus_amount || excursionDetails.is_promo
      ? excursionDetails?.new_price
      : excursionDetails?.price,
  )

  return (
    <Paper>
      <div className={s.excursionDetails}>
        <h4 className={s.excursionDetailsTitle}>{t('excursions.details')}</h4>

        <ul className={s.detailsList}>
          {startDate &&
            renderDetailItem(
              'excursions.date_start',
              dateFormat(startDate, DATE_FORMAT_LIST.FULL_DATE),
            )}
          {duration &&
            renderDetailItem(
              'excursions.duration',
              t(getDurationValue(duration)),
            )}

          {excursionType && renderDetailItem('excursions.type', excursionType)}

          {difficultyLevel &&
            renderDetailItem(
              'excursions.difficult_lvl',
              t(getDifficultValue(difficultyLevel)),
            )}

          {price &&
            renderDetailItem(
              'excursions.price_for_people',
              `${priceShow(price)} ⃀`,
            )}
        </ul>
        {isMyOrders ? (
          <div className={s.total}>
            <div className={s.flexxer}>
              <p className={clsx(s.text, 'medium-15')}>{t('total')}</p>
              <p className={clsx(s.price, 'semi-bold-18')}>
                {priceShow(totalPrice)} &#8384;
              </p>
            </div>

            {!!excursionDetails.bonus_amount && (
              <MBonusLine price={bonusAmount} />
            )}

            {!!isMplus && <BuyWithMplus />}
          </div>
        ) : (
          <MbonusLineInfo bonus={bonusAmount} />
        )}
      </div>
    </Paper>
  )
}
